import { render } from "./CostiFinanziariSottoprogetto.vue?vue&type=template&id=754dfdac&scoped=true&ts=true"
import script from "./CostiFinanziariSottoprogetto.vue?vue&type=script&lang=ts"
export * from "./CostiFinanziariSottoprogetto.vue?vue&type=script&lang=ts"

import "./CostiFinanziariSottoprogetto.vue?vue&type=style&index=0&id=754dfdac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754dfdac"]])

export default __exports__